module.exports = __webpack_public_path__ + "static/img/认知智能算法平台.2a17017.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/productArchitecture/认知智能算法平台.png
// module id = 8zoM
// module chunks = 0